export default __webpack_public_path__ + "static/SwiftDoc-terms-of-use-d9e46af7e3c211d1c6f3016ad7cacc46.pdf";